import { Link } from "react-router-dom";
import { Instagram, Facebook, Music2 } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t border-white/10 mt-20 pb-24 lg:pb-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 grid gap-8 md:grid-cols-4">
        <div>
          <div className="font-display text-2xl font-extrabold">BABI<span className="text-flame">MIX</span></div>
          <p className="text-sm text-slate-400 mt-3 max-w-xs">Les lieux. Les artistes. Les événements. Découvrez ce qui se passe autour de vous en Côte d'Ivoire.</p>
          <div className="flex gap-3 mt-4 text-slate-400">
            <a href="https://instagram.com" className="hover:text-[#FF5A00]"><Instagram className="w-5 h-5" /></a>
            <a href="https://facebook.com" className="hover:text-[#FF5A00]"><Facebook className="w-5 h-5" /></a>
            <a href="https://tiktok.com" className="hover:text-[#FF5A00]"><Music2 className="w-5 h-5" /></a>
          </div>
        </div>
        <div>
          <h4 className="font-bold mb-3 text-sm uppercase tracking-wide text-slate-300">Découvrir</h4>
          <ul className="space-y-2 text-sm text-slate-400">
            <li><Link to="/evenements" className="hover:text-white">Événements</Link></li>
            <li><Link to="/etablissements" className="hover:text-white">Établissements</Link></li>
            <li><Link to="/live" className="hover:text-white">LIVE</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-bold mb-3 text-sm uppercase tracking-wide text-slate-300">Professionnels</h4>
          <ul className="space-y-2 text-sm text-slate-400">
            <li><Link to="/business" className="hover:text-white">BABIMIX Business</Link></li>
            <li><Link to="/tarifs" className="hover:text-white">Abonnements</Link></li>
            <li><Link to="/faq" className="hover:text-white">FAQ</Link></li>
            <li><Link to="/connexion" className="hover:text-white">Créer ma page</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-bold mb-3 text-sm uppercase tracking-wide text-slate-300">Villes</h4>
          <ul className="space-y-2 text-sm text-slate-400">
            <li>Abidjan · Cocody</li>
            <li>Marcory · Zone 4</li>
            <li>Plateau · Yopougon</li>
            <li className="text-slate-500">Bientôt : Sénégal, Bénin...</li>
          </ul>
        </div>
      </div>
      <div className="text-center text-xs text-slate-500 border-t border-white/5 py-5">© {new Date().getFullYear()} BABIMIX — Tous droits réservés.</div>
    </footer>
  );
}
